import * as React from 'react';
import {
  Box,
  spacingTokenMap,
  GDSSpaceToken,
  GDSBoxProps,
} from '@leagueplatform/genesis-core';

interface SidebarLayoutProps extends GDSBoxProps<React.ElementType> {
  space?: GDSSpaceToken;
  isSideBarOnRight?: boolean;
  minInlineSize?: string;
  sidebarWidth?: string;
}

export const SidebarLayout = ({
  space = 'two',
  minInlineSize = '50%',
  sidebarWidth,
  isSideBarOnRight,
  css,
  ...args
}: SidebarLayoutProps) => (
  <Box
    css={{
      gap: spacingTokenMap[space],
      flexWrap: 'wrap',
      display: 'flex',

      '& > :first-child': isSideBarOnRight
        ? {
            flexBasis: 0,
            flexGrow: 999,
            minInlineSize,
          }
        : {
            flexGrow: 1,
            flexBasis: sidebarWidth,
          },

      '& > :last-child': isSideBarOnRight
        ? {
            flexGrow: 1,
            flexBasis: sidebarWidth,
          }
        : {
            flexBasis: 0,
            flexGrow: 999,
            minInlineSize,
          },
      ...css,
    }}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...args}
  />
);
